'use strict';

var blz = window.blz || {};
blz.domain = blz.domain || '';
blz.eventTracking = require('./services/tracking/event-tracking-service');

// General
require('./components/banner-countdown');
require('./components/main');
require('./components/carousel');
require('./components/menu');
require('./components/next-path');
require('./components/youtube-embed');
require('./components/dataLayer');
require('./components/netinfo');
require('./components/banner-expansive');
require('./components/go-to-item');
require('./components/cart');
require('./components/order-progress');
require('./components/modal');
require('./components/newsletter');
require('./components/brands-menu'); // só pra desktop
require('./components/pace');
require('./components/reviews');
require('./components/notify-me');
require('./components/event');
require('./components/billboard');
require('./components/checkbox-modal');
require('./components/nav-tabs');
require('./components/load-more');
require('./components/facet-filter');
require('./components/keep-shopping');
require('./components/wish-list');
require('./components/smartbanner');
require('./components/autocomplete');
require('./components/mailtip');
require('./components/personify-profile');
require('./components/questions');
require('./components/dropdown-our-stores');
require('./components/customer-service');
require('./components/porn-hover');
require('./components/cookiepolicy');
require('./components/onesignal');
require('./components/dataLayerEC');
require('./components/hiring');

// Home
require('./components/search-mobile');
require('./components/experts');
require('./components/recommendations-home');

// Others
require('./components/chat');
require('./components/faq');

// Pyshical store
require('./components/scroll-to');

//nars
require('./components/resize-logo');

//Beauty Box
require('./components/capillary-schedule');

//beautybox
require('./components/accessibility');

require('./components/scroll-event');
require('./components/modal-iframe');
require('./components/modal-info');

//Quem disse, berenice ?
require('./components/virtual-mirror');
require('./components/qdb-questions');
require('./components/clipboard');

// Boti
require('./components/boti-questions');
